import { render, staticRenderFns } from "./manageAssistantTeacherBar.vue?vue&type=template&id=68828526&"
import script from "./manageAssistantTeacherBar.vue?vue&type=script&lang=js&"
export * from "./manageAssistantTeacherBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports